<template>
    <path d="M3.45455 9.3457H12.5455C12.7965 9.3457 13 9.54921 13 9.80025C13 10.0513 12.7965 10.2548 12.5455 10.2548H3.45455C3.20351 10.2548 3 10.0513 3 9.80025C3 9.54921 3.20351 9.3457 3.45455 9.3457Z" />
    <path d="M3.45455 5.70898H12.5455C12.7965 5.70898 13 5.91249 13 6.16353C13 6.41457 12.7965 6.61808 12.5455 6.61808H3.45455C3.20351 6.61808 3 6.41457 3 6.16353C3 5.91249 3.20351 5.70898 3.45455 5.70898Z" />
</template>
